import format from "date-fns/format";
import React, { useState } from "react";
import { HiOutlineArrowRight, HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./limitedMobile.scss";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  ticket: Ticket;
}
const LimitedTicketMobile: React.FC<IProps> = ({ ticket }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <React.Fragment>
      <div className="purchased-assort-mobile">
          <div className="purchased-assort-mobile__title">
            <div className="purchased-assort-mobile__title__startIcon">
              <HiOutlineTicket />
            </div>
            <h5>{ticket.name}</h5>
          </div>

          <div className="purchased-assort-mobile__line"></div>
          <div className="purchased-assort-mobile__body">
            <div className="purchased-assort-mobile__body__detal">
              <HiOutlineArrowRight className="icon" />
              {t("wazny_od")}: {format(ticket.validfrom, "dd.MM.yyyy")}r.
            </div>
            <div className="purchased-assort-mobile__body__detal">
              <HiOutlineArrowRight className="icon" />
              {t("wazny_do")}: {format(ticket.validto, "dd.MM.yyyy")}r.
            </div>
            <div className="purchased-assort-mobile__body__detal">
              <HiOutlineArrowRight className="icon" />
              {ticket.entrances - ticket.exercises.length > 200 ? (
                <b>
                  {t("pozostalo")}: bez limitu {t("wejsc")}
                </b>
              ) : (
                <b>
                  {" "}
                  {t("pozostalo")}: {ticket.entrances - ticket.exercises.length} {t("wejsc")}
                </b>
              )}
            </div>
          </div>

          <div className="purchased-assort-mobile__action">
       
            <EAButton title={t("pokaz_kod_qr")} onClick={() => setOpen(!open)} fullWidth endIcon={<HiQrcode />} />
          </div>
        </div>

      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <EAButton title={t("gotowe_schowaj")} onClick={() => setOpen(!open)} fullWidth />
        </ModalComponent>
      )}
    </React.Fragment>
  );
};

export default LimitedTicketMobile;
